<template>
  <div class="ui-pop" v-show="info.show">
    <div class="ui-mask"></div>
    <div class="ui-modal large scroll">
      <p class="title">{{ $t('doc') }}</p>
      <div class="content">
        <div class="row" v-for="(item, index) in courseList" :key="item.id">
          <div class="ppt">{{ item.coursewareName }}</div>
          <!-- 下载文件 -->
          <a class="btn-download" @click="download(item.coursewareId)"
            >Download</a
          >
          <!-- 删除 -->
          <a
            class="btn-delete"
            @click="delCourse(index)"
            v-if="user.uid === item.uploadUserId"
            >Delete</a
          >
          <p class="desc">{{ $t('msg') }}：{{ item.coursewareRemark }}</p>
          <div class="info">
            <!-- 上传人 -->
            <span>Uploaded by：{{ item.uploadUser }}</span>
            <!-- 上传时间 -->
            <span>Upload time：{{ getTime(item.uploadTime) }}</span>
          </div>
        </div>
        <div class="form">
          <p class="lab">{{ $t('msg') }}</p>
          <textarea class="area" v-model="coursewareRemark"></textarea>
          <p class="lab">{{ $t('atta') }}</p>
          <el-upload
            :action="upAddress"
            :on-success="handSuccess"
            name="upload"
            :data="{ fn: 'edu' }"
            :show-file-list="false"
          >
            <div class="update">
              <a class="btn-update">{{ $t('form.upload') }} {{ $t('atta') }}</a>
            </div>
          </el-upload>
          <div
            style="margin-top: 10px"
            v-for="(item, index) in courseArr"
            :key="index"
          >
            <div class="ppt">{{ item.origFileName }}</div>
            <a class="btn-delete" @click="courseArr.splice(index, 1)">删除</a>
          </div>
        </div>
        <div class="btns">
          <a class="ui-btn gray" @click="info.show = false">{{
            $t('close')
          }}</a>
          <a class="ui-btn" @click="addCourseware">{{ $t('common.submit') }}</a>
        </div>
      </div>
    </div>
    <comfirm
      @submit="comfirmNext"
      @cancel="comfirmInfo.show = false"
      :info="comfirmInfo"
    />
  </div>
</template>
<script>
import { addCourseware, getCoursewareList, delCourseware, downloadCourseware } from '@/service/api.js'
import baseUrl from '@/service/env.js'
import comfirm from './Comfirm.vue'
import moment from 'moment'
export default {
  props: ['info', 'course'],
  components: { comfirm },
  data() {
    return {
      comfirmInfo: {
        show: false,
        title: this.$t('common.tip'),
        topic: this.$t('sureDel'),
        desc: '',
        cancel: this.$t('cancel'),
        comfirm: this.$t('common.comfirm')
      },
      coursewareRemark: '',
      idx: 0,
      upAddress: baseUrl + '/upload/uploadDoc',
      courseArr: [], // 上传的课件列表
      courseList: [] // 获取到的课件列表
    }
  },
  methods: {
    async addCourseware() {
      console.log(this.coursewareRemark);
      let coursewareName = '', coursewareUrl = '';
      if (this.courseArr.length > 0) {
        coursewareName = this.courseArr[0].origFileName;
        coursewareUrl = this.courseArr[0].url;
      }
      const res = await addCourseware({ orderCourseId: this.course.id, teacherId: this.course.teacherId, studentId: this.course.studentId, coursewareName, coursewareRemark: this.coursewareRemark, coursewareUrl })
      if (res.data.status === 1) {
        this.$message({ type: 'success', message: this.$t('common.uploadSuccess') })
        this.info.show = false
      }
    },
    handSuccess(res, file) {
      this.courseArr.push(res)
    },
    async getCourseList() {
      const res = await getCoursewareList({ orderCourseId: this.course.id, studentId: this.course.studentId, teacherId: this.course.teacherId })
      if (res.data.status === 1) {
        this.courseList = res.data.data
      }
    },
    getTime(time) {
      return moment(time * 1000).format('DD/MM/YYYY HH:mm')
    },
    async download(id) {
      const res = await downloadCourseware({ coursewareId: id })
      if (res.data.status === 1) {
        window.open(res.data.data)
      }
    },
    async comfirmNext() {
      const res = await delCourseware({ coursewareId: this.courseList[this.idx].coursewareId })
      if (res.data.status === 1) {
        this.comfirmInfo.show = false
        this.courseList.splice(this.idx, 1)
      }
    },
    delCourse(i) {
      this.comfirmInfo.show = true
      this.idx = 0
    }
  },
  computed: {
    user() {
      return JSON.parse(this.$store.getters.GETUSER)
    }
  },
  created() {
    this.getCourseList()
  }
}
</script>
<style lang="scss" scoped>
.title {
  padding: 50px 0 43px;
  border-bottom: 1px solid #d6d6d6;
  line-height: 42px;
  font-size: 32px;
  text-align: center;
}
.content {
  padding: 0 50px;
}
.row {
  padding: 50px 0;
  border-bottom: 1px dashed #ddd;
}
.ppt {
  height: 100px;
  padding: 25px;
  text-align: center;
  min-width: 265px;
  border-radius: 10px;
  background: rgba(64, 169, 255, 0.1);
  display: inline-block;
  line-height: 50px;
  font-size: 16px;
  color: #002147;
  margin-right: 30px;
  vertical-align: top;
  &:before {
    position: relative;
    top: -5px;
    content: '';
    display: inline-block;
    width: 50px;
    height: 60px;
    background: url(../assets/file.jpg);
    background-size: cover;
    margin-right: 20px;
    vertical-align: top;
  }
}
.btn-download,
.btn-delete {
  display: inline-block;
  width: 100px;
  height: 100px;
  border-radius: 10px;
  text-align: center;
  padding-top: 58px;
  line-height: 19px;
}
.btn-download {
  background: rgba(0, 33, 71, 0.1) url(../assets/download.png) center 24px
    no-repeat;
  color: #002147;
  margin-right: 14px;
}
.btn-delete {
  background: rgba(255, 0, 104, 0.1) url(../assets/delete.png) center 24px
    no-repeat;
  color: #ff0068;
}
.desc {
  margin-top: 20px;
  font-size: 18px;
  line-height: 24px;
}
.info {
  margin-top: 10px;
  color: #999;
  span {
    margin-right: 30px;
  }
}
.form {
  padding-top: 40px;
}
.lab {
  margin-bottom: 20px;
  font-size: 18px;
}
.area {
  width: 100%;
  height: 190px;
  border: 1px solid #ddd;
  padding: 10px 20px;
  line-height: 24px;
  margin-bottom: 30px;
  resize: none;
  &:focus {
    border-color: #002147;
  }
}
.update {
  width: 600px;
  height: 60px;
  border: 1px solid #ddd;
  margin-bottom: 20px;
}
.btn-update {
  float: right;
  min-width: 160px;
  height: 60px;
  padding: 0 15px;
  margin: -1px;
  background: #002147;
  text-align: center;
  line-height: 60px;
  color: #fff;
  font-size: 18px;
}
.btns {
  padding: 90px 0 100px;
}
</style>
<i18n>
{
  "cn": {
    "doc": "课件",
    "msg": "留言",
    "atta": "附件",
    "close": "关闭",
    "sureDel":"确定要删除课件吗？"
  },
  "TW": {
    "doc": "課件",
    "msg": "留言",
    "atta": "附件",
    "close": "關閉",
    "sureDel":"確定要删除課件嗎？"
  },
  "en": {
    "doc": "Lesson Docs",
    "msg": "Message",
    "atta": "Attachment",
    "close": "Close",
    "sureDel":"Are you sure you want to delete the courseware?"
  }
}
</i18n>